<template>
  <div :class="{inline:inline}">
    <template v-for="(item,index) in currentList">
      <render
        v-if="item.type === 'formItemRender' || item.type === 'formItemRenderText'"
        :key="index+item.prop+type"
        :render="item.render"
        :params="item"
      ></render>
      <FormItem
        v-else
        :key="'FormItem'+index+item.prop+type"
        :class="{inline:inline,block:item.display === 'block'}"
        :label-width="item.label?(item.labelWidth?item.labelWidth:labelWidth):0"
        :prop="item.prop"
        :rules="item.rules|filterRules(trigger)"
      >
        <template
          v-if="item.label"
          #label
        >
          {{ item.label }}
          <Tooltip
            v-if="item.tooltip"
            placement="top"
          >
            <Icon
              type="md-help-circle"
              size="18"
              color="#999"
              style="line-height: 0;"
            />
            <div
              slot="content"
              style="white-space: normal;"
              v-html="item.tooltip"
            >
            </div>
          </Tooltip>
          {{ labelColon?'：':'' }}
        </template>

        <template v-if="item.children">
          <template v-for="(sitem,sindex) in item.children">
            <MyFormItemField
              :key="index+item.prop+type+sindex"
              v-model="params[sitem.prop]"
              v-bind="sitem"
              :type="sitem.type"
              :style="{width:getFormItemWidth(sitem,item.children.length)}"
              :placeholder="sitem.placeholder?sitem.placeholder:(input.includes(sitem.type)?'请输入':'请选择')+sitem.label"
              :class="['formItem-field',{'formItem-field-detail':type==='detail','formItem-field1':sindex<item.children.length-1,block:sitem.display === 'block'}]"
              v-on="sitem.on"
            ></MyFormItemField>
            <div
              v-if="sitem.tip"
              :key="index+item.prop+'_tip_'+type+sindex"
              class="form-item-tip"
              v-html="sitem.tip"
            ></div>
          </template>
        </template>
        <MyFormItemField
          v-else
          v-model="params[item.prop]"
          :type="item.type"
          :style="{width:getFormItemWidth(item)}"
          :placeholder="item.placeholder?item.placeholder:(input.includes(item.type)?'请输入':'请选择')+item.label"
          v-bind="item"
          v-on="item.on"
        ></MyFormItemField>
        <div
          v-if="item.tip"
          class="form-item-tip"
          v-html="item.tip"
        ></div>
        <slot :name="item.prop+'After'"></slot>
      </FormItem>
      <slot :name="item.prop+'AfterOut'"></slot>
    </template>
    <slot></slot>
  </div>
</template>
<script>
import render from '@/components/Base/Render';
export default {
  components: {render},
  filters: {
    filterRules: (val, trigger) => {
      // 是否表单提交时才表单验证
      let rules = [];
      if (trigger === 'submit' && Array.isArray(val)) {
        rules = val.map(ele => ({
          ...ele,
          trigger: 'submit',
        }));
      } else {
        rules = val;
      }
      return rules;
    },
    // filterType: (val, type) => {
    //   // 是否是详情页面
    //   let newType = val;
    //   if (type === 'detail' && !/Text$/.test(val)) {
    //     newType = `${val}Text`;
    //   }
    //   return newType;
    // },
  },
  inheritAttrs: false,
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    trigger: {
      type: String,
      default: 'submit',
    },
    type: {
      type: String,
      default: 'edit',
    },
    formItemWidth: {
      type: [String, Number],
      default: 400,
    },
    labelWidth: {
      type: Number,
      default: 130,
    },
    labelColon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      params: this.value,
      currentList: [],
      input: ['text', 'password', 'textarea', 'url', 'email', 'number', 'tel', 'input'],
    };
  },
  watch: {
    value: {
      handler() {
        if (this.value !== this.params) {
          this.params = this.value;
        }
      },
    },
    list: {
      handler() {
        this.currentList = this.formatList();
      },
      deep: true,
      immediate: true,
    },
    params: {
      handler() {
        if (this.value !== this.params) {
          this.$emit('input', this.params);
        }
      },
    },
  },
  methods: {
    formatList() {
      const getList = (list, currentList = []) => {
        if (list && list.length) {
          list.forEach((item) => {
            const ele = { ...item };
            // 如果是详情类型,
            if (this.type === 'detail') {
              if (!['render', 'formItemRender'].includes(ele.type)) {
                ele.type += 'Text';
              }
              delete ele.tip;
              ele.rules = [{ required: false }];
            }

            if (ele.asyncRender && typeof ele.asyncRender === 'function') {
              ele.render = () => {}; // 添加该属性是为了监听到数据变化
              ele.asyncRender(ele);
            }
            if (ele.children && ele.children.length) {
              ele.children = getList(ele.children);
            }
            currentList.push(ele);
          });
        }
        return currentList;
      };
      return getList([...this.list]);
    },
    getFormItemWidth(item, length) {
      let width = this.formItemWidth;
      if (item.formItemWidth) {
        width = item.formItemWidth;
      } else if (length) {
        if (item.display !== 'block') {
          width = Number(this.formItemWidth) / 2 - 10;
        }
      }
      if (width) {
        return `${width}px`;
      } else {
        return '';
      }
    },
  },
};
</script>
<style lang="less" scoped>
.formItem-field {
  display: inline-block;
  // width: 190px;
  vertical-align: top;
}
.formItem-field1 {
  margin-right: 20px;
}
.formItem-field-detail {
  width: unset;
}
.inline {
  display: inline-block;
  margin-right: 20px;
}
.block {
  display: block;
}
</style>
